import { SVG, SVGProps } from './svg'

export function IconChartPie(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="m20.9 10.8.1-.3A8 8 0 0 0 13.5 3l-.3.1-.2.4V11h7.5c.1 0 .3 0 .4-.2ZM11 13h7.5a.5.5 0 0 1 .5.5A8 8 0 1 1 10.5 5a.5.5 0 0 1 .5.5V13Z" />
    </SVG>
  )
}
